import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  checkedValue: boolean = false;
  focused: boolean;
  @Output() checkedChange = new EventEmitter();
  @Input()
  get checked() {
    return this.checkedValue;
  }
  set checked(val) {
    this.checkedValue = val;
    this.checkedChange.emit(this.checkedValue);
  }

  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  toggle() {
    if (this.disabled || this.readonly) {
      return;
    }
    this.checked = !this.checked;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!this.focused || this.disabled || this.readonly) {
      return;
    }

    const x = event.keyCode;
    if (x === 32) {
      this.toggle();
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/checkbox/checkbox.component.ts